NtechApp.JobSendResumeManager = function() {
    var me = this;

    this._ajax = null;
    this._click = null;
    this._sendJobResumeConfirmForm = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._sendJobResumeConfirmForm = new NtechApp.ModalForm();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerSendResumeToJob]", function(event) {
            if(!NtechApp.clientSettings.isPersonal) {
                NtechApp.info.on("Only personal accounts can apply to jobs.", 2500);
                return;
            }

            var $control = $(event.target).closest("[data-triggerSendResumeToJob]");
            var jobId = $control.attr("data-jobId");

            if($control.hasClass("lockedButton"))
                return;

            $control.addClass("lockedButton");

            if($control.attr("data-controlAction") == "save")
                me._loadSendJobResumeConfirmForm(jobId, $control);
            else if($control.attr("data-controlAction") == "remove") {
                NtechApp.confirmForm.load(function() {
                    me._rejectJobResume(jobId, $control);
                }, function() {
                    $control.removeClass("lockedButton");
                });
            }
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobSendResumeManager, {
    _enableControlLoader: function($item) {
        var me = this;

        $item.find("[data-ajaxHide]").css("display", "none");

        $item.attr("data-ajaxLoaderOriginalText", $item.text());
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));
    },

    _disableControlLoader: function($item) {
        var me = this;

        $item.find("[data-ajaxHide]").css("display", "inline-block");
        $item.removeClass("lockedButton");

        me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
        $item.find("[data-ajaxLoaderText]").text($item.attr("data-ajaxLoaderOriginalText"));
    },

    _loadSendJobResumeConfirmForm: function(jobId, $item) {
        var me = this;
        var params = {
            jobId: jobId
        };
        me._enableControlLoader($item);

        me._sendJobResumeConfirmForm.load("personal_load_send_job_resume_confirm_form", function($form) {
            me._disableControlLoader($item);

            me._click.listen($form, "[data-closeForm]", function(e) {
                me._sendJobResumeConfirmForm.unload();
            });

            var loader = new NtechApp.Loader(35, 35, "absolute", $form.find(".formContent"));
            var overlay = new NtechApp.Overlay(
                $form.find(".formContent"), {position: "absolute", height: "100% !important"}
            );

            me._click.listen($form.find("[data-sendControl]"), function(e) {
                var $control = $(e.target).closest("[data-sendControl]");
                if($control.hasClass("lockedButton"))
                    return;

                $control.addClass("lockedButton");
                var sendResumeType = $control.attr("data-sendResumeType");

                me._sendJobResume($form, $control, $item, loader, overlay, jobId, sendResumeType);
            });
        });
    },

    _sendJobResume: function($form, $control, $sendResumeControl, loader, overlay, jobId, sendResumeType) {
        var me = this;
        var origText = $control.text();
        $control.text("");

        me._ajax.enableTextLoading($control);
        overlay.on();
        loader.on();

        var params = {
            jobId: jobId,
            sendResumeType: sendResumeType
        };
        
        me._ajax.post({
            url: Routing.generate("personal_send_job_resume"),
            data: params,
            onSuccess: function(data) {
                $sendResumeControl.attr("data-controlAction", "remove");
                $sendResumeControl.find(".controlText").text("Reject Resume");

                me._sendJobResumeConfirmForm.unload();
                var count = parseInt($("[data-jobApplicantsCounter]").text(), 10);
                $("[data-jobApplicantsCounter]").text(++count);

                var msg = "You have successfully applied to job.";
                NtechApp.info.on(msg, 2500);
            },
            onComplete: function() {
                $control.removeClass("lockedButton");
                $control.text(origText);

                me._ajax.disableTextLoading($control);

                loader.off();
                overlay.off();
            }
        });
    },

    _rejectJobResume: function(jobId, $item) {
        var me = this;
        var params = {
            jobId: jobId
        };
        me._enableControlLoader($item);

        me._ajax.post({
            url: Routing.generate("personal_cancel_send_job_resume"),
            data: params,
            onSuccess: function(data) {
                $item.attr("data-controlAction", "save");
                $item.find(".controlText").text("Send Resume");

                NtechApp.confirmForm.unload();
                var count = parseInt($("[data-jobApplicantsCounter]").text(), 10);
                $("[data-jobApplicantsCounter]").text(--count);

                var msg = "You have successfully rejected your resume.";
                NtechApp.info.on(msg, 2500);
            },
            onComplete: function() {
                me._disableControlLoader($item);
            }
        });
    }
});